import { Box, Toolbar, Typography } from '@mui/material';
import {
  StoreEnum,
  UserTypeEnum,
  contextDefaultAppRoutes,
  theme,
  useStore
} from '@myorg/shared';
import { useNavigate, useLocation } from 'react-router-dom';

export default function ContextHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const userStore = useStore(StoreEnum.UserStore);
  const uiStore = useStore(StoreEnum.UiStore);
  const context = contextDefaultAppRoutes.find(
    f => f.userType === (userStore.user?.userType ?? UserTypeEnum.Visitor)
  );

  const openExternal = (externalUrl : string) => {
    uiStore.openIframe(externalUrl);
  }

  return (
    <Toolbar
      sx={{
        display: 'flex',
        justifyContent: 'center',
        marginLeft: "5rem"
      }}
    >
      {context &&
        context.headerItems.map(item => (
          <Box
            key={item.description}
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              p: 2
            }}
          >
            <Box
              sx={{
                display: 'flex',
                pb: 0.5,
                alignItems: 'center',
                borderBottomWidth: '0.2rem',
                borderBottomStyle: 'solid',
                borderBottomColor: 'transparent',
                height: '100%',
                minHeight: '2.5rem',
                transition:
                  'border-bottom-width 0.5s ease-out, padding-bottom 0.5s ease-out',
                '&:hover': {
                  borderBottomColor: theme.palette.primary.main,
                  transition:
                    'border-bottom-width 0.5s ease-out, padding-bottom 0.5s ease-out'
                },
                ...(location.pathname === item.href && {
                  borderBottomColor: theme.palette.primary.main
                })
              }}
            >
              {/* <item.icon
                sx={{
                  mr: 0.5,
                  color: theme.palette.primary.main,
                  cursor: 'pointer',
                  fontSize: '1.15rem'
                }}
              /> */}
              <Typography
                sx={{
                  fontWeight: 500,
                  textDecoration: 'none',
                  color: theme.palette.primary.main,
                  cursor: 'pointer'
                }}
                onClick={() => item.external ? openExternal(item.href) :  navigate(item.href)}
              >
                {item.description}
              </Typography>
            </Box>
          </Box>
        ))}
    </Toolbar>
  );
}
